import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../components/button';
import { back, forward } from './calendarSlice';

const CalendarBackForward = () => {
    const { t } = useTranslation();
    return (<>
        <div className="calendar-back-forward">
            <Button type="left" className="small-button"
                action={back}
                help={t('calendar.back')} />
            <Button type="right" className="small-button"
                action={forward}
                help={t('calendar.forward')} />
        </div>
    </>);
}

export default CalendarBackForward;